import {
  type GetStaticProps,
  type GetStaticPropsContext,
  type NextPageWithLayout,
} from 'next'
import React, { type ReactNode } from 'react'
import { ConsultationsPageView } from '@public/CmsPage/ConsultationsPage'
import { useCmsConsultationPageBySlug } from '@public/CmsPage/ConsultationsPage/hooks/useCMSConsultationPageBySlug'
import { prepareGetStaticPropsForConsultationsPage } from '@public/CmsPage/ConsultationsPage/prepareGetStaticPropsForConsultationsPage'
import { getPublicLayout } from '@public/components/PublicLayout'
import { CONSULTATIONS_PAGE_SLUG } from 'constants/common'

interface LayoutOptions {
  isFullWidth: boolean
  isWithBreadcrumbs: boolean
}

const LAYOUT_OPTIONS: LayoutOptions = {
  isFullWidth: true,
  isWithBreadcrumbs: true,
}

export const Consultations: NextPageWithLayout = () => {
  const { pageBySlug, isLoading, widgets } = useCmsConsultationPageBySlug({
    slug: CONSULTATIONS_PAGE_SLUG,
    isConsultationsIndexPage: true,
  })

  return (
    <ConsultationsPageView
      slug={CONSULTATIONS_PAGE_SLUG}
      data={pageBySlug}
      isLoading={isLoading}
      widgets={widgets}
      fallbackMetaTitle="Consult Top Interior Designers Online - The Expert"
      fallbackDescription="Book online consultations with top interior designers like Jake Arnold and Leanne Ford. Our design services deliver real-time advice on renovations, layouts, furniture, and more."
    />
  )
}

export const getStaticProps: GetStaticProps = (
  context: GetStaticPropsContext
) =>
  prepareGetStaticPropsForConsultationsPage(context, {
    slug: CONSULTATIONS_PAGE_SLUG,
  })

const PageLayout = (page: ReactNode): JSX.Element =>
  getPublicLayout(page, LAYOUT_OPTIONS)

Consultations.getLayout = PageLayout
